import React, { useEffect, useState } from "react";
import * as APIModels from "../../../../models";
import { TylerAdminService } from "../../../../services/ClientService";
import {
    Modal,
    Button,
    Form,
    Row,
    Col,
    ToggleButton,
    ButtonGroup,
} from "react-bootstrap";

class TylerRole {
    name: string;
    value: number;

    constructor(params: { name: string; value: number }) {
        this.name = params.name;
        this.value = params.value;
    }
}

async function update(user: APIModels.TylerUser): Promise<APIModels.TylerUser> {
    const response = await TylerAdminService.putUser({ body: user });
    if (response.successful && response.data) {
        return response.data;
    } else {
        throw new Error(response.errorMessage);
    }
}

export default function UserUpdateModal(params: {
    addUserModal: boolean;
    close: (value: boolean) => void;
    user: APIModels.TylerUser;
    users: APIModels.TylerUser[];
    setUsers: (value: APIModels.TylerUser[]) => void;
}): JSX.Element {
    // state
    const [updateUser, setUpdateUser] = useState({} as APIModels.TylerUser);
    const [modalEM, setModalEM] = useState("");

    useEffect(() => {
        console.log({ user: params.user });
        setUpdateUser(params.user);
    }, [params.user]);

    const update = (u: APIModels.TylerUser) => {
        const temp: APIModels.TylerUser = {
            ...u,
            name: u.firstName + " " + u.lastName,
        };
        TylerAdminService.putUser({ body: u })
            .then((res) => {
                if (res.successful! && res.data!) {
                    params.close(false);
                    window.location.reload();
                } else {
                    setModalEM(res.errorMessage!);
                }
            })
            .catch((err) => {
                setModalEM(err);
            });

        /*

        params.setUsers((prev: { id: string | undefined }[]) => {
            const index = prev.findIndex(
                (user: { id: string | undefined }) => user.id === u.id
            );
            prev[index] = temp;
            return [...prev];
        });
        */
        const prev = [...params.users];
        const index = prev.findIndex((user) => user.id === u.id);
        prev[index] = temp;
        params.setUsers(prev);
    };

    return (
        <div>
            <Modal show={params.addUserModal}>
                <Form>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "Blue" }}>
                            Update a User
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridFN">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    placeholder="John"
                                    value={updateUser.firstName!}
                                    onChange={(event) => {
                                        const update =
                                            event.currentTarget.value;
                                        setUpdateUser((prev) => {
                                            return {
                                                ...prev,
                                                firstName: update,
                                            };
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridLN">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    placeholder="Smith"
                                    value={updateUser.lastName!}
                                    onChange={(event) => {
                                        const update =
                                            event.currentTarget.value;
                                        setUpdateUser((prev) => {
                                            return {
                                                ...prev,
                                                lastName: update,
                                            };
                                        });
                                    }}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Please Enter The user's Email"
                                    value={updateUser.username!}
                                    onChange={(event) => {
                                        const update =
                                            event.currentTarget.value;
                                        setUpdateUser((prev) => {
                                            return {
                                                ...prev,
                                                emailAddress: update,
                                                username: update,
                                            };
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridEmail">
                                {updateUser.active! ? (
                                    <Button
                                        variant="primary"
                                        disabled={true}
                                        size="lg"
                                    >
                                        User Activated
                                    </Button>
                                ) : (
                                    <Button
                                        variant="secondary"
                                        disabled={true}
                                        size="lg"
                                    >
                                        User Not Activated
                                    </Button>
                                )}
                            </Form.Group>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="submit"
                            className="btn btn-success"
                            onClick={(e) => {
                                e.preventDefault();
                                update(updateUser);
                            }}
                            style={{ float: "left" }}
                        >
                            <i className="ri-user-add-fill" /> Update
                        </button>
                        {modalEM && modalEM != "" ? (
                            <p style={{ color: "red", float: "none" }}>
                                {modalEM}
                            </p>
                        ) : (
                            <></>
                        )}
                        <Button
                            variant="secondary"
                            onClick={() => params.close(false)}
                            style={{ float: "right" }}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
}
